import { render, staticRenderFns } from "./settingWorkDocsSchemeClass.vue?vue&type=template&id=3d24a16f&"
import script from "./settingWorkDocsSchemeClass.vue?vue&type=script&lang=js&"
export * from "./settingWorkDocsSchemeClass.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports